import isEmpty from 'lodash/isEmpty';
import { getUrlImagePath } from 'common/utilities/utils';
import { RESTRICTED_BAD_WORDS } from 'common/constants/restrictionWords';
import { checkRestrictedWords } from 'organisms/AccountPage/AU/accountPageUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  ADD_HOPE_BUTTON,
  INPUT,
  CUSTOM_ADD_HOPE_DONATE_AMOUNT_REGEX,
  IMAGE_SIZE_CONSTANTS,
  ADD_HOPE,
  SESSION_STORAGE_KEYS,
  PURCHASE_TYPE,
} from 'common/constants/SharedConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { paymentForAddHope } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';

const { ADDHOPE_ITEMS } = IMAGE_SIZE_CONSTANTS;
export const getAddHopeContentData = fields => {
  const items = fields.body?.map(item => item.fields);
  if (!isEmpty(items) && ADD_HOPE === fields.title) {
    return {
      headLine: items[1]?.headline,
      longText: items[1]?.longText,
      desktopImage: getUrlImagePath(
        items[0]?.image?.fields?.file?.url,
        ADDHOPE_ITEMS.ADDHOPE_IMAGE_WIDTH_DESKTOP,
        ADDHOPE_ITEMS.ADDHOPE_IMAGE_HEIGHT_DESKTOP,
      ),
      mobileImage: getUrlImagePath(
        items[0]?.mobileImage?.fields?.file?.url,
        ADDHOPE_ITEMS.ADDHOPE_IMAGE_WIDTH_MOBILE,
        ADDHOPE_ITEMS.ADDHOPE_IMAGE_HEIGHT_MOBILE,
      ),
      shortText: items[1]?.shortText,
      richText1: items[1]?.richText?.content[0]?.content[0]?.value,
      richText2: items[1]?.richText?.content[1]?.content[0]?.value,
      richText3: items[1]?.richText?.content[2]?.content[0]?.value,
      bucketImage: getUrlImagePath(
        items[2]?.image?.fields?.file?.url,
        ADDHOPE_ITEMS.BUCKET_IMAGE_WIDTH_DESKTOP,
        ADDHOPE_ITEMS.BUCKET_IMAGE_HEIGHT_DESKTOP,
      ),
      displayLine1: items[2]?.headline,
      displayLine2: items[2]?.subHeadline,
      addHopeFormHeadLine: items[3].headline,
      addHopeFormTitle: items[3].title,
      addHopeButton: items[3].formField[5].fields.buttonText,
      snapScanHeadline: items[4].headline,
      snapScanImage: getUrlImagePath(
        items[4]?.image?.fields?.file?.url,
        ADDHOPE_ITEMS.SNAPSCAN_IMAGE_HEIGHT_DESKTOP,
        ADDHOPE_ITEMS.SNAPSCAN_IMAGE_WIDTH_DESKTOP,
      ),
      snapScanExternalURL: items[4].cta.fields.externalurl,
      donationOptions: items[3].formField?.[3]?.fields.values,
      defaultDonationValue: items[3].formField?.[3]?.fields.defaultValue,
    };
  }
};

export const prepareFormData = params => {
  const {
    AddHopeData,
    donationsButtonData,
    setDonationsButtonData,
    currencySymbol,
    tenantId,
    dispatch,
    currencyConversionFactor,
  } = params;
  const dataUpdated = [];
  AddHopeData?.items?.[0]?.fields.body?.[3]?.fields?.formField.forEach(formElement => {
    const {
      fields,
      sys: { id },
    } = formElement;
    const returnData = {
      ...fields,
      className: 'formElement',
      key: id,
      rules: {
        required: {
          value: formElement?.fields?.required ? formElement?.fields?.required : false,
          message: `${translateWithI18Next(
            TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
          )} ${formElement?.fields?.label?.toLowerCase()}`,
        },
        pattern: {
          value: formElement?.fields?.pattern ? RegExp(formElement?.fields?.pattern) : null,
          message: `${translateWithI18Next(
            TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
          )} ${formElement?.fields?.label?.toLowerCase()}`,
        },
        validate: textvalue =>
          formElement?.fields?.type === INPUT
            ? !checkRestrictedWords(RESTRICTED_BAD_WORDS, textvalue) ||
              `${translateWithI18Next(
                TRANSLATE_MAPPING_KEY?.INVALID_TEXT,
              )} ${formElement?.fields?.label?.toLowerCase()}`
            : true,
      },
      onChangeHandler: onFormElementChangeHandler,
      onBlurHandler: onFormElementChangeHandler,
      isMandatory: formElement?.fields?.required ? formElement?.fields?.required : false,
      maxLength: formElement?.fields?.maxLength ? formElement?.fields?.maxLength : '',
    };
    if (formElement?.fields?.name !== 'addHopePreAmount') {
      dataUpdated.push(returnData);
    } else {
      dataUpdated.push({
        ...returnData,
        name: `addHopePreAmount`,
        type: 'donationButtonGroup',
        donationsButtonData: donationsButtonData,
        onClickDonationHandler: handleSelectedClick,
        currencySymbol: currencySymbol,
        setDonationsButtonData: setDonationsButtonData,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        onChangeInputHandler: onChangeOrOnBlurHandler,
        onClearDonationTextHandler: clearAmountHandler,
        onClickDonationAddHandler: addTipAmountHandler,
        tenantId: tenantId,
        dispatch: dispatch,
        currencyConversionFactor: currencyConversionFactor,
      });
    }
  });
  return dataUpdated;
};

export const onFormElementChangeHandler = formConfig => {
  const fieldValues = formConfig?.getValueFromElements?.();
  const addHopeDetails = { ...formConfig?.addHopeDetails };
  addHopeDetails.addHopefirstName = fieldValues?.addHopefirstName;
  addHopeDetails.addHopeLastName = fieldValues?.addHopeLastName;
  addHopeDetails.addHopeEmail = fieldValues?.addHopeEmail;
  addHopeDetails.addHopePreAmount = fieldValues?.addHopePreAmount;
  formConfig?.updateAddHopeDetails({
    ...addHopeDetails,
  });
};

export const updatedShowFields = (formFormFeildsData, setFormFormFeildsData) => {
  setFormFormFeildsData({ ...formFormFeildsData });
};

export const handleSelectedClick = (selectedObj, index, componentData) => {
  const { donationsButtonData, setDonationsButtonData, currencySymbol } = componentData;
  const driverTippingChargeSelected = donationsButtonData?.donationChargeOption?.map((obj, i) => {
    return {
      ...obj,
      isDefault: index === i ? true : false,
    };
  });
  setDonationsButtonData({
    ...donationsButtonData,
    donationChargeOption: driverTippingChargeSelected,
    addDonationBtnHandler: true,
    editButtonShow: false,
    showCurrencyField: true,
    customAmount: selectedObj.displayNonPercentageAmount.split(currencySymbol).join(''),
    defaultTipSelected: true,
    inputFiledValidErrormsg: '',
    readOnly: true,
  });
};

export const handleFocus = componentData => {
  const { donationsButtonData, setDonationsButtonData } = componentData;
  setDonationsButtonData({ ...donationsButtonData, showCurrencyField: true, defaultTipSelected: true });
};

export const setDataForInvalidAmount = (event, donationsButtonData, setDonationsButtonData) => {
  setDonationsButtonData({
    donationChargeOption: donationsButtonData.donationChargeOption.map(obj => {
      return {
        ...obj,
        displayNonPercentageAmount: obj.displayNonPercentageAmount,
        isDefault: obj === false,
      };
    }),
    showNonDonationPercentage: true,
    showDonationsCustomFields: true,
    addDonationBtnHandler: true,
    donationRegexPattern: CUSTOM_ADD_HOPE_DONATE_AMOUNT_REGEX,
    customAmount: event.target.value,
    showCurrencyField: !!event.target.value,
    buttonText: ADD_HOPE_BUTTON,
    inputFiledValidErrormsg: translateWithI18Next(TRANSLATE_MAPPING_KEY?.TIPPING_INVALID_MSG),
    isAddHopeFlow: true,
    defaultTipSelected: false,
  });
};

export const handleBlur = (event, componentData) => {
  const { donationsButtonData, setDonationsButtonData } = componentData;
  const defaultValue = donationsButtonData.donationChargeOption.find(values => values.isSelected === true);
  setDonationsButtonData({
    donationChargeOption: donationsButtonData.donationChargeOption.map(obj => {
      return {
        ...obj,
        displayNonPercentageAmount: obj.displayNonPercentageAmount,
        isDefault: obj === defaultValue ? true : false,
      };
    }),
    showNonDonationPercentage: true,
    showDonationsCustomFields: true,
    addDonationBtnHandler: true,
    donationRegexPattern: CUSTOM_ADD_HOPE_DONATE_AMOUNT_REGEX,
    customAmount: event.target.value,
    showCurrencyField: !!event.target.value,
    buttonText: ADD_HOPE_BUTTON,
    inputFiledValidErrormsg: '',
    isAddHopeFlow: true,
    defaultTipSelected: true,
  });
};

export const onChangeOrOnBlurHandler = (event, componentData) => {
  const { donationsButtonData, setDonationsButtonData } = componentData;
  const value = parseInt(event.target.value);
  if (value < 1) {
    setDataForInvalidAmount(event, donationsButtonData, setDonationsButtonData);
  } else {
    setDonationsButtonData({
      donationChargeOption: donationsButtonData.donationChargeOption.map(obj => {
        return {
          ...obj,
          displayNonPercentageAmount: obj.displayNonPercentageAmount,
          isDefault: false,
        };
      }),
      showNonDonationPercentage: true,
      showDonationsCustomFields: true,
      addDonationBtnHandler: true,
      inputFiledValidErrormsg: '',
      donationRegexPattern: CUSTOM_ADD_HOPE_DONATE_AMOUNT_REGEX,
      customAmount: event.target.value,
      showCurrencyField: !!event.target.value,
      buttonText: ADD_HOPE_BUTTON,
      isAddHopeFlow: true,
      defaultTipSelected: false,
    });
  }
};

export const clearAmountHandler = componentData => {
  const { donationsButtonData, setDonationsButtonData } = componentData;
  const defaultValue = donationsButtonData.donationChargeOption.find(values => values.isSelected === true);
  setDonationsButtonData({
    donationChargeOption: donationsButtonData?.donationChargeOption.map(values => {
      return {
        ...values,
        isDefault: values === defaultValue ? true : false,
      };
    }),
    showNonDonationPercentage: true,
    showDonationsCustomFields: true,
    addDonationBtnHandler: true,
    customAmount: '',
    inputFiledValidErrormsg: '',
    donationRegexPattern: CUSTOM_ADD_HOPE_DONATE_AMOUNT_REGEX,
    editButtonShow: false,
    buttonText: ADD_HOPE_BUTTON,
    showCurrencyField: false,
    isAddHopeFlow: true,
    defaultTipSelected: true,
  });
};

export const addTipAmountHandler = componentData => {
  const { donationsButtonData, dispatch, tenantId, setDonationsButtonData, currencyConversionFactor, addHopeDetails } =
    componentData;
  sessionStorage.setItem(SESSION_STORAGE_KEYS.POST_PAYMENT_TYPE, PURCHASE_TYPE.ADD_HOPE_PURCHASE);
  const transactionDate = new Date().toISOString().slice(0, -5);
  setDonationsButtonData({
    ...donationsButtonData,
    addDonationBtnHandler: true,
    isAddHopeButtonClicked: true,
    isAddHopeFlow: true,
  });
  const defaultValue = donationsButtonData?.donationChargeOption.find(values => values.isDefault === true);
  const defaultValueWithCurrencySymbol = defaultValue?.values?.slice(1);
  const payload = {
    firstName: addHopeDetails?.addHopefirstName,
    lastName: addHopeDetails?.addHopeLastName,
    email: addHopeDetails?.addHopeEmail,
    miscPaymentTypeId: 'add-hope-donate',
    amount: donationsButtonData?.defaultTipSelected
      ? defaultValueWithCurrencySymbol?.slice(0, -3) * currencyConversionFactor
      : donationsButtonData?.customAmount * currencyConversionFactor,
    transactionDate: transactionDate,
    tenderType: 'credit-card',
  };
  dispatch(
    paymentForAddHope({
      tenantId,
      data: payload,
    }),
  );
};
